webpackJsonp([278102253565233],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.ce879f02.png";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.750dd581.png";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projects = __webpack_require__(24);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _carousel = __webpack_require__(27);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _iphone = __webpack_require__(28);
	
	var _iphone2 = _interopRequireDefault(_iphone);
	
	var _macbook = __webpack_require__(29);
	
	var _macbook2 = _interopRequireDefault(_macbook);
	
	var _outboundLink = __webpack_require__(13);
	
	var _outboundLink2 = _interopRequireDefault(_outboundLink);
	
	var _wrapper = __webpack_require__(9);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _project = __webpack_require__(23);
	
	var _stylesModule = __webpack_require__(330);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = {
	  desktop: [{ src: __webpack_require__(200), description: "City Atlas (screenshot 1)" }, { src: __webpack_require__(526), description: "City Atlas (screenshot 2)" }],
	  mobile: [{ src: __webpack_require__(200), description: "kindyNow centre detail rooms" }]
	};
	
	var Cityatlas = function Cityatlas(_ref) {
	  var location = _ref.location;
	
	  var project = _projects2.default.find(function (p) {
	    return p.slug === "cityatlas";
	  });
	
	  var image = _react2.default.createElement(
	    "div",
	    { className: _stylesModule2.default.image },
	    _react2.default.createElement("img", { src: project.cover || images["desktop"][0]["src"], alt: "Cover" })
	  );
	
	  var iphone = _react2.default.createElement(
	    _iphone2.default,
	    { invert: true },
	    _react2.default.createElement(_carousel2.default, { images: images.mobile })
	  );
	
	  return _react2.default.createElement(
	    _project.ProjectPage,
	    { project: project, location: location },
	    _react2.default.createElement(_project.ProjectIntro, { project: project, media: image }),
	    _react2.default.createElement(
	      _wrapper2.default,
	      null,
	      _react2.default.createElement(
	        _macbook2.default,
	        null,
	        _react2.default.createElement(_carousel2.default, { images: images.desktop })
	      )
	    )
	  );
	};
	
	exports.default = Cityatlas;
	module.exports = exports["default"];

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-pages-work-cityatlas----styles-module---image---1T2lM"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-cityatlas-index-jsx-0f5fedbd60cd426c4b6a.js